import { gql } from '@apollo/client';

export const CHECK_AUTH = gql`
  query CheckAuth {
    me {
      id
      name
      nickname
      bio
      email
      profile_photo_urls {
          original
          thumbnail
          small
          medium
          large
        }
    }
  }
`;

export const VERIFY_AGE = gql`
  query VerifyAge($dateOfBirth: Date!) {
    verifyAge(date_of_birth: $dateOfBirth) {
      verificationPassed
    }
  }
`;

export const VERIFY_EMAIL = gql`
  query VerifyEmail($email: String!) {
    verifyEmail(email: $email) {
      available
    }
  }
`;

export const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(input: {
      email: $email,
      password: $password
    }) {
      user {
        id
        name
        nickname
        bio
        email
        profile_photo_urls {
          original
          thumbnail
          small
          medium
          large
        }
      }
    }
  }
`;

export const REGISTER = gql`
  mutation Register($name: String!, $email: String!, $password: String!, $dateOfBirth: Date!) {
    signup(input: {
      name: $name,
      email: $email,
      password: $password,
      date_of_birth: $dateOfBirth
    }) {
      user {
        id
        name
        nickname
        bio
        email
        profile_photo_urls {
          original
          thumbnail
          small
          medium
          large
        }
      }
    }
  }
`;

export const LOGOUT = gql`
  mutation Logout {
    logout {
      success
      message
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(input: {
      email: $email
    }) {
      success
    }
  }
`;

export const CHECK_PASSCODE = gql`
  query CheckPasscode($email: String!, $code: String!) {
    checkForgottenPasscode(
      email: $email,
      code: $code
    ) {
      token
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($token: String!, $password: String!) {
    changeForgottenPassword(input: {
      token: $token,
      password: $password
    }) {
      success
    }
  }
`;

export const SOCIAL_AUTH = gql`
  mutation SocialAuth($provider: String!, $code: String!, $state: String) {
    socialAuth(provider: $provider, code: $code, state: $state) {
      user {
        id
        name
        email
      }
    }
  }
`;

export const GET_MY_PROFILE = gql`
  query GetMyProfile {
    me {
      id
      name
      nickname
      bio
      profile_photo_urls {
        thumbnail
        medium
        large
      }
      followers_count
      following_count
      applauses_count
    }
  }
`; 